import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="url-param"
export default class extends Controller {
    static values = {
        param: String,
        url: String
    }

    declare paramValue: string
    declare urlValue: string

    change(event: Event) {
        const select = event.target as HTMLSelectElement
        const value = select.value
        const url = new URL(this.urlValue || window.location.href)

        url.searchParams.set(this.paramValue, value)

        // Use Turbo to visit the new URL
        // @ts-ignore
        if (window.Turbo) {
            // @ts-ignore
            window.Turbo.visit(url.toString(), { action: "advance" })
        } else {
            window.location.href = url.toString()
        }
    }
}
